import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import { cn } from "@volca/ui/lib/utils";
import { ACTIVE_TEXT, useActiveRow } from "./statement-item-action";
import { StatementItemActionButton } from "./statement-item-action-button";
import type { KeyValueBlock } from "./statement-schema";
import { SectionHeading } from "./statement-section-heading";

const KeyValueRow = ({
  row,
  heading,
}: {
  row: KeyValueBlock["rows"][number];
  heading?: string;
}) => {
  const active = useActiveRow({
    heading,
    line: row.label ?? undefined,
    amount: row.value,
  });

  return (
    <Stack
      className="w-full"
      direction="row"
      align="baseline"
      justify="between"
      gap={4}
    >
      <Text variant="caption" tone="muted">
        {row.label}
      </Text>
      <Stack direction="row" align="center" gap={0} className="shrink-0">
        <Text
          variant="caption"
          className={cn("shrink-0 text-right", {
            "font-semibold": row.strong,
          })}
        >
          <span className={cn({ [ACTIVE_TEXT]: active })}>{row.value}</span>
        </Text>
        <StatementItemActionButton
          heading={heading}
          line={row.label ?? undefined}
          amount={row.value}
        />
      </Stack>
    </Stack>
  );
};

export const KeyValue = ({ block }: { block: KeyValueBlock }) => (
  <Stack align="start" gap={0} className="w-full gap-3">
    {block.heading && <SectionHeading left={block.heading} />}
    <Stack align="start" gap={0} className="w-full gap-2.5">
      {block.rows.map((row, index) => (
        <KeyValueRow
          key={index}
          row={row}
          heading={block.heading ?? undefined}
        />
      ))}
    </Stack>
  </Stack>
);
